import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { CONTACT, LOGO_FULL, LEGAL_LINKS } from "../../data/content";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#F9FAF8] border-t border-black/5 pt-16 pb-10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12">
          <div className="md:col-span-5">
            <img
              src={LOGO_FULL}
              alt="Instalaciones de fontanería · Alejandro García · Fontaneros en Huelva"
              className="h-40 w-auto object-contain -ml-2"
            />
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#5AB82D] mb-5">Contacto</h4>
            <ul className="space-y-3 text-sm text-[#0A1F10]">
              <li>
                <a href={`tel:${CONTACT.phoneRaw}`} className="inline-flex items-center gap-3 hover:text-[#5AB82D] transition-colors font-semibold">
                  <Phone className="w-4 h-4 text-[#5AB82D]" /> 722 29 49 23
                </a>
              </li>
              <li>
                <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 hover:text-[#5AB82D] transition-colors font-semibold">
                  <WhatsAppIcon className="w-4 h-4 text-[#5AB82D]" /> WhatsApp directo
                </a>
              </li>
              <li>
                <a href="mailto:alexgarciamicuenta@gmail.com" className="inline-flex items-center gap-3 hover:text-[#5AB82D] transition-colors">
                  <Mail className="w-4 h-4 text-[#5AB82D]" /> alexgarciamicuenta@gmail.com
                </a>
              </li>
              <li className="inline-flex items-center gap-3 text-[#4B5E51]">
                <MapPin className="w-4 h-4 text-[#5AB82D]" /> Huelva capital y alrededores
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#5AB82D] mb-5">Servicios</h4>
            <ul className="space-y-2 text-sm text-[#4B5E51]">
              <li><a href="#servicios" className="hover:text-[#5AB82D] transition-colors">Humedades y fugas</a></li>
              <li><a href="#servicios" className="hover:text-[#5AB82D] transition-colors">Tuberías y multicapa</a></li>
              <li><a href="#servicios" className="hover:text-[#5AB82D] transition-colors">Termos y grifería</a></li>
              <li><a href="#servicios" className="hover:text-[#5AB82D] transition-colors">Reformas integrales</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-black/5">
          <nav data-testid="footer-legal-links" className="flex flex-wrap gap-x-6 gap-y-2 mb-6">
            {LEGAL_LINKS.map((l) => (
              <Link
                key={l.slug}
                to={`/legal/${l.slug}`}
                data-testid={`legal-link-${l.slug}`}
                className="text-sm font-semibold text-[#5AB82D] hover:underline underline-offset-4 transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#4B5E51]">
            <span>© {new Date().getFullYear()} Alejandro García · Fontanero en Huelva</span>
            <span>Puntualidad · Honradez · Confirmación previa</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
